module.exports = __webpack_public_path__ + "img/audio-play.0d022352.svg";